var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnCheckedDot = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8712 8.88487C15.038 8.72608 15.2599 8.6383 15.4902 8.64004C15.7205 8.64178 15.9411 8.73292 16.1054 8.89421C16.2698 9.0555 16.3651 9.27434 16.3712 9.50454C16.3773 9.73475 16.2937 9.95831 16.1381 10.1281L11.4139 16.0362C11.3327 16.1237 11.2347 16.1939 11.1257 16.2427C11.0167 16.2914 10.899 16.3177 10.7796 16.3199C10.6602 16.3221 10.5416 16.3002 10.4309 16.2555C10.3202 16.2108 10.2196 16.1443 10.1352 16.0599L7.00236 12.927C6.91511 12.8457 6.84513 12.7477 6.7966 12.6388C6.74807 12.5298 6.72197 12.4123 6.71986 12.293C6.71776 12.1738 6.73969 12.0554 6.78436 11.9448C6.82902 11.8342 6.89549 11.7338 6.97982 11.6495C7.06414 11.5651 7.16458 11.4987 7.27515 11.454C7.38572 11.4093 7.50416 11.3874 7.62339 11.3895C7.74262 11.3916 7.86021 11.4177 7.96913 11.4662C8.07806 11.5148 8.1761 11.5848 8.25739 11.672L10.7367 14.1501L14.8487 8.91092C14.8561 8.9018 14.864 8.8931 14.8724 8.88487H14.8712Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnCheckedDot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unCheckedDot.fff826e8.svg";
export { ForwardRef as ReactComponent };